
/* injects from baggage-loader */

'use strict';

const productFieldsDirective = angular.module('product.setting', []);

productFieldsDirective.filter('toArray', [
  '$timeout', function($timeout) {
    return function(obj) {
      const result = [];
      _.each(obj, function(val, hash) {
        return result.push({
          name: val,
          value: hash
        });
      });
      return result;
    };
  }
]);

productFieldsDirective.directive('productFieldsSetting', [
  '$window', '$timeout', '$compile', '$templateCache', 'ns', 'translitService', 'ContentEditable', 'Widget', 'blockEditDialog', 'Slider', '$rootScope',
  ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, Slider, $rootScope) => {
    return {
      restrict: 'A',
      scope: {
        data: '=ngModel'
      },
      templateUrl: settingFolder + '/productfields/template.jade',
      link: (scope, element, attrs, ngModel) => {
        const id = attrs.widgetId;
        const widgetElWrapper = angular.element('[data-block-id=' + id + ']').find(ns.widgetWrapperClass);
        const sectionId = blockEditDialog.getSectionId({id: id});

        scope.product = angular.copy(scope.data);
        scope.Editor = angular.copy(window.Editor);
        scope.productTypes = [{
          item_type: 'image',
          title: 'widget.product.elementType1'
        }, {
          item_type: 'text',
          title: 'widget.product.elementType2'
        }, {
          item_type: 'button',
          title: 'widget.product.elementType3'
        }, {
          item_type: 'list',
          title: 'widget.product.elementType4'
        }];

        const sortProductItems = function() {
          const product_items_ids = [];
          const ref = scope.product.product_items_attributes;

          for (let index = 0, i = 0, len = ref.length; i < len; index = ++i) {
            const product_item = ref[index];

            product_item.position = index;
            if (product_item.id) {
              product_items_ids.push(product_item.id);
            }
          }

          return Widget.sortProductItems(attrs.widgetId, product_items_ids);
        };

        const trimNbsp = function(fields) {
          var field, i, len;
          for (i = 0, len = fields.length; i < len; i++) {
            field = fields[i];
            field.text = field.text.replace(/&nbsp;/gi, '');
          }
          return fields;
        };

        const getNotDestroyedFieldRnd = function() {
          var fields;
          fields = [];
          _.each(scope.product.product_items_attributes, function(field, index) {
            if (!field._destroy) {
              return fields.push(index);
            }
          });
          if (fields.length > 0) {
            return fields[fields.length - 1];
          } else {
            return 0;
          }
        };

        const setItemsStyles = function(newVal) {
          _.each(newVal, function(item) {
            widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__image-wrapper').css(item.image_style_attributes);
            widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__image-wrapper').css({
              height: item.image_wrapper_height
            });
            widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__title').css(item.text_style_attributes);
            widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strwcrd__button').css(item.button_attributes.style_attributes);
            return widgetElWrapper.find('.strwcrd-item-' + item.id).find('.strbw_list-item__caption').css(item.caption_style_attributes);
          });
          return widgetElWrapper.find('.strwcrd').css(scope.data.wrapper_style);
        };

        const renderProduct = function() {
          let allHtml = "<div class='strwcrd'>";
          _.each(scope.product.product_items_attributes, function(item, index) {
            let itemHtml;
            let imageHtml = '';
            let imageWithStretch = '';
            let textHtml = '';
            let buttonHtml = '';
            let listHtml = '';

            if (!item._destroy) {
              if (item.item_type === 'image') {
                imageHtml = "<div class='strwcrd__image-size'><div class='strwcrd__image-wrapper strwcrd__image-no-cover'><img class='strwcrd__image' src='" + item.file_url + "'></div></div>";
                imageWithStretch = "<div class='strwcrd__image-size'><div class='strwcrd__image-wrapper strwcrd__image-no-cover'><div class='strwcrd__image strwcrd__image_cover' style='background-image: url(" + item.file_url + ")'></div></div></div>";
              }
              if (item.item_type === 'text') {
                textHtml = "<span class='strwcrd__title' contenteditable='false' spellcheck='false' data-access='product_items_attributes." + index + ".text'>" + item.text + "</span>";
              }
              if (item.item_type === 'button') {
                buttonHtml = "<a href='" + item.button_attributes.scroll_section_id + "' contenteditable='false' spellcheck='false' data-access='product_items_attributes." + index + ".button_attributes.value' class='link-anchor strwcrd__button'>" + item.button_attributes.value + "</a>";
              }
              if (item.item_type === 'list') {
                listHtml = "<ul class='strbw_list strbw_list-card'>";
                _.each(item.rows_attributes, function(row, rowindex) {
                  if (!row._destroy) {
                    listHtml += "<li data-item-id='" + row.id + "' style='background-image:url(" + item.bullet_url + ")'><span class='strbw_list-item__caption' contenteditable='false' data-access='product_items_attributes." + index + ".rows_attributes." + rowindex + ".caption'>" + row.caption + "</span></li>";
                  }
                });
                listHtml += "</ul>";
              }
            }
            itemHtml = "<div class='strwcrd-item strwcrd-item-" + item.id + "'> " + imageHtml + " " + textHtml + " " + buttonHtml + " " + listHtml + " </div>";
            allHtml += itemHtml;
          });
          allHtml += "</div>";

          widgetElWrapper.html(allHtml);
          setItemsStyles(scope.product.product_items_attributes);
          ContentEditable.bind(false, true, id);
        };

        scope.treeOptions = {
          dropped: () => {
            $timeout(() => {
              sortProductItems();
              renderProduct();
            });
          }
        };
        scope.currentField = getNotDestroyedFieldRnd();
        scope.setCurrentField = function(index) {
          scope.currentField = void 0;
          $timeout(function() {
            scope.currentField = index;
          });
        };
        scope.add = function() {
          const params = {
            product_items_attributes: [
              {
                remote_file_url: 'http://api.siter.io/assets/widgets/link/img.jpg',
                item_type: 'text',
                position: scope.product.product_items_attributes.length + 1
              }
            ]
          };
          scope.addingField = true;
          return sortProductItems().then(function() {
            Widget.createItem(sectionId, id, params).then(function(data) {
              var length, newSlide;
              newSlide = data.product_items_attributes[data.product_items_attributes.length - 1];
              scope.product.product_items_attributes.push(newSlide);
              length = scope.product.product_items_attributes.length;
              scope.setCurrentField(data.product_items_attributes.length - 1);
              scope.addingField = false;
              return renderProduct();
            });
            return ContentEditable.bind(false, true, id);
          });
        };

        scope.renderProduct = renderProduct;
        scope.fieldsLength = function(fields) {
          var destroyed;
          destroyed = _.filter(fields, {
            _destroy: true
          });
          return fields.length - destroyed.length;
        };
        scope.remove = function() {
          var index;
          index = scope.product.product_items_attributes.indexOf(scope.product.product_items_attributes[scope.currentField]);
          if (index > -1) {
            Widget.destroyProductItem(scope.product.id, scope.product.product_items_attributes[scope.currentField].id).then(sortProductItems);
            scope.product.product_items_attributes.splice(index, 1);
            scope.currentField = getNotDestroyedFieldRnd();
          }
          return renderProduct();
        };

        const listener1 = scope.$watch('product.product_items_attributes', function(newVal, oldVal) {
          scope.data.product_items_attributes = trimNbsp(newVal);
          setItemsStyles(newVal);
          return ContentEditable.bind(false, true, id);
        }, true);

        const listener2 = scope.$watch('data.wrapper_style', function(newVal, oldVal) {
          scope.data.wrapper_style = scope.product.wrapper_style;
          return widgetElWrapper.find('.strwcrd').css(scope.data.wrapper_style);
        }, true);

        scope.$on('$destroy', function() {
          listener1();
          listener2();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/productfields/productfields.directive.js